import {esclusioniOnResponseError} from "../config/presdoc-fe-services-util"
const axios = require('axios');

class AjaxService {
  constructor(rootStore, onRequestConfig, onRequestConfigError, onResponse, onResponseError, onNoServerResponse) {
    this.rootStore = rootStore
    this.onRequestConfig = onRequestConfig && (typeof onRequestConfig === 'function') ? onRequestConfig : () => { }
    this.onRequestConfigError = onRequestConfigError && (typeof onRequestConfigError === 'function') ? onRequestConfigError : () => { }
    this.onResponse = onRequestConfig && (typeof onResponse === 'function') ? onResponse : () => { }
    this.onResponseError = onResponseError && (typeof onResponseError === 'function') ? onResponseError : () => { }
    this.onNoServerResponse = onNoServerResponse && (typeof onNoServerResponse === 'function') ? onNoServerResponse : () => { }
  }


  doAjax(method, path, data){
    let basePath = process.env.REST_PATH
    let apiPath =process.env.API_REST_PATH

    let uri = `${path}`

   // console.log(`***************doAjax path ${path} `)

    if(path.startsWith("/infouser")){
      uri = `${basePath}${apiPath}${path}`
    }

    if(uri.includes("?")) {
      uri =  `${uri}&v=${Date.now()}`
    } else {
      uri =  `${uri}?v=${Date.now()}`
    }
     // console.log(`***************doAjax ${uri} `)
    //const uri = `${path}?v=${Date.now()}`
    let config = {
      method: method,
      url: uri,
      data: data ? JSON.stringify(data) : null,
      headers: {
        "Content-Type": "application/json"
      }
    }

    this.onRequestConfig.call(this, config)
    let request = axios(config);

    return request.then(response => {
      // console.debug(`request ${uri} - config ${JSON.stringify(response)}`)
      this.onResponse.call(this, response)
      return { success: true, result: response.data }
    })
      .catch(error => {
        
        if (error.response) {
          if(!esclusioniOnResponseError.some(servizio => path.includes(servizio)))
          {
            this.onResponseError.call(this, error)
          }
          return { success: false, result: error.response.data }
        } else if (error.request) {
          this.onNoServerResponse.call(this, error)
          console.debug(`no response received ${uri} - error ${JSON.stringify(error.request)}`)
        } else {
          this.onRequestConfigError.call(this, error)
          console.debug(`request config error ${uri} - error ${JSON.stringify(error.message)}`)
        }
        console.debug(`request ${uri} - config ${JSON.stringify(error.config)}`)
        return { success: false}
      });
  }
  /*
  doAjax_old(method, path, data) {
    //let basePath = process.env.CONTEXT_PATH
   // debugger
    let basePath = process.env.REST_PATH
    console.log("doAjax_old")
    console.log("process.env.NODE_ENV: " + process.env.NODE_ENV)
    console.log("path origin: " + path)
    if(process.env.NODE_ENV === 'development')
    {
      if (path.startsWith("/ext")) { //prova a chiamare
        path = path.replace("/ext/","")
         basePath = ""
        console.log("1*path: "+path +" ,basepath: "+basePath)
      }
      else {
        path = path.replace("/rs", "/api");
        console.log("path replace: " + path)
        basePath = process.env.CONTEXT_PATH
        if (path.startsWith("/infouser"))
          path = "/api" + path
      }
    }

    if(process.env.NODE_ENV === 'none')
    {
      if(path.startsWith("/api"))
        basePath= process.env.CONTEXT_PATH
        if(path.startsWith("/infouser"))
          path="/rs"+path
    }

    //let apiPath = process.env.NODE_ENV === 'development' ? '/api' : '/rs'
    console.log("2*path: "+path +" ,basepath: "+basePath)
    let apiPath =""
    const uri = `${basePath}${apiPath}${path}?v=${Date.now()}`
    //const uri = `${path}?v=${Date.now()}`
    console.log("uri path: " + uri)
    let config = {
      method: method,
      url: uri,
      data: data ? JSON.stringify(data) : null,
      headers: {
        "Content-Type": "application/json"
      }
    }

    this.onRequestConfig.call(this, config)
    let request = axios(config);

    return request.then(response => {
      //console.debug(`request ${uri} - config ${JSON.stringify(response)}`)
      this.onResponse.call(this, response)
      return { success: true, result: response.data }
    })
      .catch(error => {
        if (error.response) {
          this.onResponseError.call(this, error)
          return { success: false, result: error.response.data }
        } else if (error.request) {
          this.onNoServerResponse.call(this, error)
          console.debug(`no response received ${uri} - error ${JSON.stringify(error.request)}`)
        } else {
          this.onRequestConfigError.call(this, error)
          console.debug(`request config error ${uri} - error ${JSON.stringify(error.message)}`)
        }
        console.debug(`request ${uri} - config ${JSON.stringify(error.config)}`)
      });
  }
  */
/*
  doAjaxDownload(method, path){
   // debugger;
    let basePath = process.env.REST_PATH
    let apiPath =""
    
    const uri = `${basePath}${apiPath}${path}?v=${Date.now()}`
    console.log(`***************doAjaxDownload ${uri} `)
    //const uri = `${path}?v=${Date.now()}`
    let config = {
      method: method,
      url: uri,
      
      headers: {
        "Content-Type": "application/json"
      }
    }

    this.onRequestConfig.call(this, config)
    let request = axios(config);

    return request.then(response => {

      if(response && response.statusText=='OK'){
//TODO da gestire con file saver
       
//let disposition = response.headers["Content-Disposition"];

 //       var blob = response.blob().then((blob) => {
 //         let url = window.URL.createObjectURL(blob);
 //         let a = document.createElement('a');
 //         a.href = url;
 //         a.download = "Ricevuta.pdf";
 //         a.click();


            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'file.pdf');
            document.body.appendChild(link);
            link.click();


      //  // });
      }else{
        console.log("Errore download")
      }
    })   
  }
*/
}

export default AjaxService;